import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Logger } from '@app/logging.service';
import { Observable, Subscription } from 'rxjs';

export interface LoadingModalData {
  message: string;
  unitOfWork: Observable<any>;
}

@Component({
  selector: 'app-loading-modal',
  templateUrl: './loading-modal.component.html',
  styleUrls: ['./loading-modal.component.scss'],
})
export class LoadingModalComponent implements OnInit, OnDestroy {
  unit$: Subscription;

  constructor(public dialogRef: MatDialogRef<LoadingModalComponent>, @Inject(MAT_DIALOG_DATA) public data: LoadingModalData) {}

  ngOnDestroy(): void {
    this.unit$.unsubscribe();
  }

  ngOnInit(): void {
    this.unit$ = this.data.unitOfWork.subscribe(
      (data) => this.dialogRef.close(data),
      (err) => {
        Logger.Log.error(err);
        this.dialogRef.close(err as Error);
      }
    );
  }
}
